var _circle, _circle2, _g, _g2, _g3, _defs, _g4, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOndes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#0A192F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "none",
    stroke: "#1E3A8A",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -25,
    width: 30,
    height: 50,
    fill: "#3B82F6",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0 Q40,-10 60,0 Q40,10 20,0",
    fill: "none",
    stroke: "#3B82F6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M20,0 Q40,-10 60,0 Q40,10 20,0;                 M20,0 Q40,-5 60,0 Q40,5 20,0;                 M20,0 Q40,-10 60,0 Q40,10 20,0",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,200)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -25,
    width: 30,
    height: 50,
    fill: "#3B82F6",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20,0 Q-40,-10 -60,0 Q-40,10 -20,0",
    fill: "none",
    stroke: "#3B82F6",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    values: "M-20,0 Q-40,-10 -60,0 Q-40,10 -20,0;                 M-20,0 Q-40,-5 -60,0 Q-40,5 -20,0;                 M-20,0 Q-40,-10 -60,0 Q-40,10 -20,0",
    dur: "2s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M140,180 L260,180",
    stroke: "#10B981",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)",
    strokeDasharray: "6,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 12,
    to: 0,
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260,220 L140,220",
    stroke: "#10B981",
    strokeWidth: 2,
    markerEnd: "url(#arrowhead)",
    strokeDasharray: "6,6"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 0,
    to: 12,
    dur: "1s",
    repeatCount: "indefinite"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrowhead",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#10B981"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,200)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#10B981",
    fontFamily: "monospace",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -30,
    y: -5
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: -5
  }, "01"), /*#__PURE__*/React.createElement("tspan", {
    x: -30,
    y: 15
  }, "01"), /*#__PURE__*/React.createElement("tspan", {
    x: 10,
    y: 15
  }, "10")), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 200 200",
    to: "360 200 200",
    dur: "20s",
    repeatCount: "indefinite"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 160,
    fill: "none",
    stroke: "#3B82F6",
    strokeWidth: 1,
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 140,
    to: 160,
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0.6,
    to: 0.1,
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 170,
    fill: "none",
    stroke: "#3B82F6",
    strokeWidth: 1,
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    from: 150,
    to: 170,
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    from: 0.4,
    to: 0.1,
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOndes);
export default __webpack_public_path__ + "static/media/Ondes.c0479102686e302035a046c9aa79003f.svg";
export { ForwardRef as ReactComponent };